import React from "react";

function formatDate(dateString, type) {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const date = new Date(dateString);

  const monthName = months[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  const timezone = Intl.DateTimeFormat(undefined, {
    timeZoneName: "short",
  }).format(date);

  const timeArray = timezone?.split(",");
  const zoneArray = timeArray[1]?.split("+");

  const formattedDate = `${monthName} ${day}, ${year}`;
  const formattedTimezone = ` - ${hours}:${minutes} ${
    zoneArray[0] ? zoneArray[0] : ""
  }`;

  if (type == "date") {
    const formattedDateTimezone = `${formattedDate}`;
    return formattedDateTimezone;
  } else {
    const formattedDateTimezone = `${formattedDate}  ${formattedTimezone}`;
    return formattedDateTimezone;
  }
}

const Incident = ({ data }) => {
  return (
    <div>
      {data?.data?.data?.pastIncidentsData?.map((incident, i) => (
        <div
          className="mt-6 flex flex-col space-y-4 "
          style={{ paddingRight: "3rem" }}
          key={i}
        >
          <div className="bg-white dark:bg-slate-900 rounded-lg px-6 py-6 ring-1 ring-slate-900/5 shadow-sm border-2 border-t-orange-500">
            <h3 className="inline-flex items-right justify-right p-2 bg-red-500 rounded-md shadow-sm text-white mt-5">
              {incident?.name}
            </h3>
            {incident?.data?.map((update, k) => {
              const formattedDateTimezone = formatDate(update?.happenedAt);
              return (
                <div key={k}>
                  <br />
                  <span
                    style={{ fontSize: "1rem", fontWeight: "600" }}
                    className="text-slate-900 dark:text-white mt-5 text-base font-medium tracking-tight"
                  >
                    {update?.updates?.message ===
                      "We are continuing to investigate this issue." ||
                    update?.updates?.message ===
                      "We are continuing to work on a fix for this issue." ||
                    update?.updates?.message ===
                      "We are continuing to monitor for any further issues."
                      ? "Update - "
                      : update?.updates?.label + " - "}
                  </span>
                  <span>{update?.message}</span>
                  <br />
                  <span style={{ color: "rgba(0, 0, 0, 0.5)" }}>
                    {formattedDateTimezone}
                  </span>
                  <br />
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Incident;
